import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useNotification from '@/shared/hooks/UseNotification';

const CONFLICT = 409;

const useHandleCreateCompanyError = () => {
  const { t } = useTranslation(['errors']);
  const { sendDefaultError, sendNotification } = useNotification();

  return useCallback(
    (error: unknown, vatNumber?: string | null) => {
      if ((error as { data?: { httpStatus?: number } })?.data?.httpStatus === CONFLICT) {
        sendNotification({
          header: t('errors:conflict'),
          message: t('errors:companyWithVatNumberAlreadyExists', { vatNumber }),
          variant: 'error',
        });
        return;
      }

      sendDefaultError(error);
    },
    [sendDefaultError, sendNotification, t],
  );
};

export default useHandleCreateCompanyError;
